<script setup lang="ts">
import { computed, onMounted, PropType, ref } from "vue";
import { OptionItemModel } from "../../../models";
import {
  PopoverColorEnum,
  PopoverPositionEnum,
  TirPmIconView,
  TirPmPopover,
  TirPmTooltipElement,
} from "tir-components";
import {
  CancelledCircleIcon,
  DoneCircleIcon,
  EmptyStatusCircleIcon,
  InProgressCircleIcon,
  PauseCircleIcon,
  StartCircleIcon,
} from "tir-style-system/icons/solid";

/**Параметры */
const props = defineProps({
  /**Данные опции фильтра */
  item: {
    type: Object as PropType<OptionItemModel>,
    required: true,
  },
  /**Укороченная информация */
  isShortInfo: { type: Boolean, default: false },
});

/**Ссылка на дом элемента фильтра */
const $itemFilter = ref<InstanceType<typeof HTMLElement>>();

/**После рендера компонента */
onMounted(() => {
  props.item.Width = $itemFilter.value?.offsetWidth;
});
/**Отображение иконок глобальных статусов */
const showIconGlobalStatuses = computed(() => {
  const status = props.item.GlobalStatusType;

  switch (status) {
    case 5:
      return StartCircleIcon;
    case 4:
      return PauseCircleIcon;
    case 3:
      return CancelledCircleIcon;
    case 2:
      return InProgressCircleIcon;
    case 1:
      return DoneCircleIcon;
    case 0:
      return EmptyStatusCircleIcon;
  }
});
</script>
<template>
  <TirPmTooltipElement v-if="isShortInfo" width="max-content">
    <component
      :is="showIconGlobalStatuses"
      :style="{ color: item.Color }"
      class="filter-parameter-statuses__icon"
    />
    <template #content>
      <div ref="$itemFilter">
        {{ item.Name }}
      </div>
    </template>
  </TirPmTooltipElement>
  <div v-else class="filter-parameter-statuses__item">
    <component
      :is="showIconGlobalStatuses"
      :style="{ color: item.Color }"
      class="filter-parameter-statuses__icon"
    />
    <div :style="{ color: item.Color }" class="filter-parameter-statuses__name">
      {{ item.Name }}
    </div>
  </div>
</template>
<style scoped lang="scss">
.filter-parameter-statuses {
  &__item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  &__icon {
    width: 1.25rem;
    height: 1.25rem;
    min-width: 1.25rem;
    min-height: 1.25rem;
  }

  &__name {
    font-size: 0.75rem;
    font-weight: 500;
    text-transform: uppercase;
  }
}
</style>
